import { logout as authLogout } from '@lib/auth';
import { createReducer, on } from '@ngrx/store';

import { HmState } from '@hm/core/models/hm-state.interface';

import { logoutUser, setUser } from './hm.actions';

const initialState: HmState = {
  user: null,
};

export const hmReducer = createReducer(
  initialState,
  on(setUser, (state, { user }) => ({
    ...state,
    user,
  })),
  on(logoutUser, state => ({ ...state, user: initialState.user })),
  on(authLogout, state => ({ ...state, user: initialState.user }))
);
